export default __webpack_public_path__ + "static/media/australian-passport-guided.ab2547de.png";